import { useEffect, useState, useContext, useRef} from 'react'
import Fetch, { GET } from '../inc/Fetch';


export default function MoeLogin() {

    const [data, setdata] = useState({})

    //window.location= `https://www.altashkeel.net//simplesaml/module.php/core/as_login.php?AuthId=default-sp&ReturnTo=https://www.altashkeel.net/moeLogin`
    async function loadData() {
        let res = await GET(`moeLogin`);
        console.log(res);
        
        setdata(res);
    }


    useEffect(() => {
        loadData();
    }, []);

    return (<>
        <div style={{ padding:20, direction:'ltr', margin:'auto', width:500, border:'1px solid black'}}>{JSON.stringify(data)}<br /><br /></div>
        <a href='https://www.altashkeel.net/simplesaml/sp_logout.php'>Logout</a>
    </>);


}
